import React from 'react';
import styled, { css } from 'styled-components';
import { FormControlBase } from '../Input/Input';
import { defaultTextCss } from '../../common/mixins';
import { ENABLED_TABINDEX_FOR_NON_INPUT } from '../../constants/commonConstants';
import { onEnterKey } from '../../common/keyboardEvents';

export interface IFormLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  attached?: 'left' | 'right';
  percentageWidth?: number;
}

const defaultAttachedLabelPercentageWidth = 20;

const leftAttachedFormLabelCss = css<IFormLabelProps>`
  float: left;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-right: 0;

  & + ${FormControlBase} {
    width: ${({ percentageWidth = defaultAttachedLabelPercentageWidth }) => 100 - percentageWidth}%;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;

const rightAttachedFormLabelCss = css<IFormLabelProps>`
  float: right;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-left: 0;

  & + ${FormControlBase} {
    width: ${({ percentageWidth = defaultAttachedLabelPercentageWidth }) => 100 - percentageWidth}%;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

const attachedFormLabelCss = css<IFormLabelProps>`
  display: inline-block;
  width: ${({ percentageWidth = defaultAttachedLabelPercentageWidth }) => percentageWidth}%;
  border: 1px solid ${({ theme }) => theme.colours.default.border};
  background-color: ${({ theme }) => theme.colours.default.background};
  margin-top: 0.5rem;
  box-sizing: border-box;
  padding: 0.75rem 0;
  text-align: center;
  height: 3rem;

  ${({ attached }) => (attached === 'left' ? leftAttachedFormLabelCss : rightAttachedFormLabelCss)}
`;

export const FormLabel = styled.label.attrs<IFormLabelProps>(({ onClick }) => ({
  tabIndex: onClick ? ENABLED_TABINDEX_FOR_NON_INPUT : undefined,
  onClick,
  onKeyDown: (e: React.KeyboardEvent<HTMLLabelElement>) => {
    onEnterKey(e, onClick);
  }
}))<IFormLabelProps>`
  ${defaultTextCss};

  line-height: ${({ theme }) => theme.text.lineHeight};
  font-size: 1rem;
  display: flex;
  font-weight: bold;

  ${({ attached }) => attached && attachedFormLabelCss}
  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `}
`;
